import styled from './index.module.scss';
import { getIsLogin } from 'lowcode/utils/getIsLogin';

export default function Descriptions({ items }: { items: Record<string, string>[] }) {
    const isLogin = getIsLogin();

    return (
        <div className={styled.description}>
            <div className={`desc_wrapper ${isLogin ? 'padtop' : ''}`}>
                {items.map((item, i) => (
                    <div className="desc_item" key={i}>
                        <div className="title">{item.title}</div>
                        <div className="content">{item.content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
